import { createContext, useContext } from 'react';

/**
 * Toast context + hook (split from `ToastProvider.tsx` so the provider file only exports a component —
 * keeps react-refresh happy). The provider supplies the real implementation; outside it, `useToast`
 * returns a no-op API so a stray call never throws (e.g. a feature rendered in isolation in a test).
 */

export type ToastTone = 'success' | 'error';

export interface ToastApi {
  /** Show a kind success/confirmation toast (polite live region). */
  readonly success: (message: string) => void;
  /** Show an error toast (assertive live region) — for failures that would otherwise be silent. */
  readonly error: (message: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

const NOOP_TOAST: ToastApi = { success: () => {}, error: () => {} };

/** Access the toast API (no-op when rendered outside a `ToastProvider`). */
export function useToast(): ToastApi {
  return useContext(ToastContext) ?? NOOP_TOAST;
}
